export enum VolumeTypeForEvents {
    main = 'main',
}
